var _a, _b;
import * as moment from 'moment';
import MomentEnum from '../../../../enums/MomentEnum';
import EventTypes from '../../../../enums/EventTypesEnum';
import TimeFormatsEnum from '../../../../enums/TimeFormatsEnum';
import WeekStartersEnum from '../../../../enums/WeekStartersEnum';
import _rrule from '@wix/moment-js-rrule';
import { SlavicLanguages } from './ExpandedEventUtilsConstants';
var capitalize = function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var multiFormatHelper = function (dateTime, timeFormat, t, experiments) {
    var momentTime = moment(dateTime);
    var month = momentTime.format(t(MomentEnum.monthName));
    var monthDay = momentTime.format(MomentEnum.dayOfMonth);
    var year = momentTime.format(MomentEnum.fullYear);
    var time = timeFormat === TimeFormatsEnum.tweleveHours
        ? momentTime.format("".concat(MomentEnum.shortHour, ":").concat(MomentEnum.fullMinute, " ").concat(MomentEnum.ampm))
        : momentTime.format("".concat(MomentEnum.fullHour, ":").concat(MomentEnum.fullMinute));
    time =
        timeFormat === TimeFormatsEnum.tweleveHours
            ? moment.locale() === 'ko'
                ? momentTime.format(" ".concat(MomentEnum.ampm, " ").concat(MomentEnum.shortHour, ":").concat(MomentEnum.fullMinute))
                : momentTime.format("".concat(MomentEnum.shortHour, ":").concat(MomentEnum.fullMinute, " ").concat(MomentEnum.ampm))
            : momentTime.format("".concat(MomentEnum.fullHour, ":").concat(MomentEnum.fullMinute));
    return t('Google_Calendar_Popup_MultiDay_Event_Part', {
        month: month,
        monthDay: monthDay,
        year: year,
        time: time,
    });
};
var localeMap = {
    'zh': 'zh-cn',
    'en': 'en-gb',
    'no': 'nb',
};
var getLocale = function (locale) {
    try {
        locale = localeMap[locale] || locale;
        require("moment/locale/".concat(locale));
        return locale;
    }
    catch (error) {
        console.log('[getLocale: error] : ', error);
        require("moment/locale/".concat(localeMap.en));
        return localeMap.en;
    }
};
export var defaultFormat = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, timeFormat = _a.timeFormat, t = _a.t, experiments = _a.experiments, _b = _a.locale, locale = _b === void 0 ? 'en' : _b;
    locale = getLocale(locale);
    moment.locale(locale);
    console.log('=================> defaultFormat moment.locale() = ', moment.locale());
    var momentStart = moment(startDate);
    var momentEnd = moment(endDate);
    var weekDay = momentStart.format(MomentEnum.fullWeekDayName);
    weekDay = capitalize(weekDay);
    var month = momentStart.format(MomentEnum.monthName);
    var monthDay = momentStart.format(MomentEnum.dayOfMonth);
    var startTime = momentStart.format("".concat(MomentEnum.fullHour, ":").concat(MomentEnum.fullMinute));
    var endTime = momentEnd.format("".concat(MomentEnum.fullHour, ":").concat(MomentEnum.fullMinute));
    if (timeFormat === TimeFormatsEnum.tweleveHours) {
        var startAMPM = momentStart.format(MomentEnum.ampm);
        var endAMPM = momentEnd.format(MomentEnum.ampm);
        var isSameAMPM = startAMPM === endAMPM;
        startTime = momentStart.format("".concat(MomentEnum.shortHour, ":").concat(MomentEnum.fullMinute, " ").concat(isSameAMPM ? '' : MomentEnum.ampm));
        endTime = momentEnd.format("".concat(MomentEnum.shortHour, ":").concat(MomentEnum.fullMinute, " ").concat(MomentEnum.ampm));
        if (moment.locale() === 'ja') {
            startTime = momentStart.format("".concat(MomentEnum.ampm).concat(MomentEnum.shortHour, ":").concat(MomentEnum.fullMinute));
            endTime = momentEnd.format("".concat(isSameAMPM ? '' : MomentEnum.ampm).concat(MomentEnum.shortHour, ":").concat(MomentEnum.fullMinute));
        }
        if (moment.locale() === 'ko') {
            startTime = momentStart.format(" ".concat(isSameAMPM ? '' : MomentEnum.ampm, " ").concat(MomentEnum.shortHour, ":").concat(MomentEnum.fullMinute));
            endTime = momentEnd.format(" ".concat(MomentEnum.ampm, " ").concat(MomentEnum.shortHour, ":").concat(MomentEnum.fullMinute));
        }
    }
    if (moment.locale() === 'ja') {
        return "".concat(moment(startDate).format(t('Google_Calendadr_Popup_AllDay_Event')) +
            ', ' +
            t('Google_Calendar_Popup_Default_Event_Full', { startTime: startTime, endTime: endTime }));
    }
    if (SlavicLanguages.includes(moment.locale())) {
        var slavicFormatDate = t('Google_Calendar_Popup_Default_Event_Full', {
            weekDay: weekDay,
            month: momentStart.format("".concat(MomentEnum.dayOfMonth, " ").concat(MomentEnum.monthName)),
            monthDay: '',
            startTime: startTime,
            endTime: endTime,
        });
        return slavicFormatDate;
    }
    var defaultFormatDate = t('Google_Calendar_Popup_Default_Event_Full', {
        weekDay: weekDay,
        month: month,
        monthDay: monthDay,
        startTime: startTime,
        endTime: endTime,
    });
    return defaultFormatDate;
};
var allDayFormat = function (_a) {
    var startDate = _a.startDate, t = _a.t;
    return moment(startDate).format(t('Google_Calendadr_Popup_AllDay_Event'));
};
var multiFormat = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, timeFormat = _a.timeFormat, t = _a.t, experiments = _a.experiments, _b = _a.locale, locale = _b === void 0 ? 'en' : _b;
    locale = locale === 'zh' ? 'zh-cn' : locale;
    locale = locale === 'en' ? 'en-gb' : locale;
    require("moment/locale/".concat(locale));
    moment.locale(locale);
    console.log('=================> multiFormat moment.locale() = ', moment.locale());
    var start = multiFormatHelper(startDate, timeFormat, t, experiments);
    var end = multiFormatHelper(endDate, timeFormat, t, experiments);
    return t('Google_Calendar_Popup_MultiDay_Event_Full', { start: start, end: end });
};
var allDayMultiFormat = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, t = _a.t, _b = _a.locale, locale = _b === void 0 ? 'en' : _b;
    locale = locale === 'zh' ? 'zh-cn' : locale;
    locale = locale === 'en' ? 'en-gb' : locale;
    require("moment/locale/".concat(locale));
    moment.locale(locale);
    console.log('=================> allDayMultiFormat moment.locale() = ', moment.locale());
    var startMonth = moment(startDate).format(MomentEnum.monthName);
    var startDay = moment(startDate).format(MomentEnum.dayOfMonth);
    var endMonth = moment(endDate).format(MomentEnum.monthName);
    var endDay = moment(endDate).format(MomentEnum.dayOfMonth);
    var year = moment(endDate).format(MomentEnum.fullYear);
    return t('Google_Calendar_Popup_AllDayMultiDay_Event', {
        startMonth: startMonth,
        startDay: startDay,
        endMonth: endMonth,
        endDay: endDay,
        year: year,
    });
};
export var formatsByType = (_a = {},
    _a[EventTypes.Default] = function (formatData) { return defaultFormat(formatData); },
    _a[EventTypes.AllDay] = function (formatData) { return allDayFormat(formatData); },
    _a[EventTypes.MultiDay] = function (formatData) { return multiFormat(formatData); },
    _a[EventTypes.AllDayMultiDay] = function (formatData) { return allDayMultiFormat(formatData); },
    _a[EventTypes.Filler] = function (formatData) {
        return formatsByType[formatData.originType](formatData);
    },
    _a);
var orderByWeekStarter = (_b = {},
    _b[WeekStartersEnum.Monday] = function (t) { return [
        t('calendar_widget_monday'),
        t('calendar_widget_tuesday'),
        t('calendar_widget_wednesday'),
        t('calendar_widget_thursday'),
        t('calendar_widget_friday'),
        t('calendar_widget_saturday'),
        t('calendar_widget_sunday'),
    ]; },
    _b[WeekStartersEnum.Sunday] = function (t) { return [
        t('calendar_widget_sunday'),
        t('calendar_widget_monday'),
        t('calendar_widget_tuesday'),
        t('calendar_widget_wednesday'),
        t('calendar_widget_thursday'),
        t('calendar_widget_friday'),
        t('calendar_widget_saturday'),
    ]; },
    _b[WeekStartersEnum.Saturday] = function (t) { return [
        t('calendar_widget_saturday'),
        t('calendar_widget_sunday'),
        t('calendar_widget_monday'),
        t('calendar_widget_tuesday'),
        t('calendar_widget_wednesday'),
        t('calendar_widget_thursday'),
        t('calendar_widget_friday'),
    ]; },
    _b);
export var getRecurrenceByRule = function (recurrenceRule, t, groupByStartDate, weekStarter) {
    if (typeof recurrenceRule !== 'string') {
        return '';
    }
    var rule = _rrule.fromString(recurrenceRule.slice(6));
    var weekdays = {
        MO: t('calendar_widget_monday'),
        TU: t('calendar_widget_tuesday'),
        WE: t('calendar_widget_wednesday'),
        TH: t('calendar_widget_thursday'),
        FR: t('calendar_widget_friday'),
        SA: t('calendar_widget_saturday'),
        SU: t('calendar_widget_sunday'),
    };
    var weekdaysOrdered = orderByWeekStarter[weekStarter](t);
    //@ts-ignore
    var byDay = rule.byDay;
    var dayOfTheWeek = byDay;
    var serial;
    if (byDay !== null && typeof byDay[0].every === 'number') {
        serial = byDay[0].every && byDay[0].every === -1 ? 5 : byDay[0].every;
        dayOfTheWeek = weekdays[byDay[0].byDay];
    }
    else if (byDay) {
        dayOfTheWeek = byDay
            .map(function (d) { return "".concat(weekdays[d]); })
            .sort(function (weekday1, weekday2) {
            return weekdaysOrdered.indexOf(weekday1) - weekdaysOrdered.indexOf(weekday2);
        })
            .join(', ');
    }
    //@ts-ignore
    var number = rule.interval;
    var dayOfTheMonth = typeof groupByStartDate === 'undefined' ? '' : groupByStartDate.slice(-2);
    var MonthlyKeys = [
        '',
        t('calendar_widget_monthlyOnTheFirst_DayOfTheWeek', { dayOfTheWeek: dayOfTheWeek }),
        t('calendar_widget_monthlyOnTheSecond_DayOfTheWeek', { dayOfTheWeek: dayOfTheWeek }),
        t('calendar_widget_monthlyOnTheThird_DayOfTheWeek', { dayOfTheWeek: dayOfTheWeek }),
        t('calendar_widget_monthlyOnTheForth_DayOfTheWeek', { dayOfTheWeek: dayOfTheWeek }),
        t('calendar_widget_monthlyOnTheLast_DayOfTheWeek', { dayOfTheWeek: dayOfTheWeek }),
    ];
    var MonthlyKeysWithInterval = [
        '',
        t('calendar_widget_every_Number_MonthsOnTheFirst_DayOfTheWeek', {
            dayOfTheWeek: dayOfTheWeek,
            number: number,
        }),
        t('calendar_widget_every_Number_MonthsOnTheSecond_DayOfTheWeek', {
            dayOfTheWeek: dayOfTheWeek,
            number: number,
        }),
        t('calendar_widget_every_Number_MonthsOnTheThird_DayOfTheWeek', {
            dayOfTheWeek: dayOfTheWeek,
            number: number,
        }),
        t('calendar_widget_every_Number_MonthsOnTheForth_DayOfTheWeek', {
            dayOfTheWeek: dayOfTheWeek,
            number: number,
        }),
        t('calendar_widget_every_Number_MonthsOnTheLast_DayOfTheWeek', {
            dayOfTheWeek: dayOfTheWeek,
            number: number,
        }),
    ];
    var mykey = '';
    // mykey = MonthlyKeys[serial];
    var yearlyDate = moment(groupByStartDate, 'YYYY-MM-DD').format('MMM DD');
    var interval = 'interval';
    var freq = 'freq';
    switch (rule[freq]) {
        case 'DAILY':
            {
                mykey =
                    rule[interval] === null
                        ? t('calendar_widget_daily')
                        : t('calendar_widget_Every_Number_Days', { number: number });
            }
            break;
        case 'WEEKLY':
            {
                if (rule[interval] === null) {
                    //@ts-ignore
                    mykey =
                        //@ts-ignore
                        rule.byDay === null
                            ? t('calendar_widget_weekly')
                            : t('calendar_widget_weeklyOn_DayOfTheWeek', { dayOfTheWeek: dayOfTheWeek });
                }
                else {
                    //@ts-ignore
                    mykey =
                        //@ts-ignore
                        //rule.byDay === null
                        rule.byDay.length === 7
                            ? t('calendar_widget_every_Number_WeeksOnAllDays', { number: number })
                            : t('calendar_widget_every_Number_WeeksOn_DayOfTheWeek', {
                                dayOfTheWeek: dayOfTheWeek,
                                number: number,
                            });
                }
            }
            break;
        case 'MONTHLY':
            {
                //@ts-ignore
                if (rule.byDay === null) {
                    mykey =
                        rule[interval] === null
                            ? t('calendar_widget_monthlyOnDay_DayOfTheMonth', {
                                dayOfTheMonth: dayOfTheMonth,
                            })
                            : t('calendar_widget_every_Number_MonthsOnDay_DayOfTheMonth', {
                                dayOfTheMonth: dayOfTheMonth,
                                number: number,
                            });
                }
                else {
                    mykey =
                        rule[interval] === null
                            ? MonthlyKeys[serial]
                            : MonthlyKeysWithInterval[serial];
                }
            }
            break;
        case 'YEARLY':
            {
                mykey =
                    rule[interval] === null
                        ? t('calendar_widget_annuallyOn_Date', { yearlyDate: yearlyDate })
                        : t('calendar_widget_every_Number_YearsOn_Date', {
                            yearlyDate: yearlyDate,
                            number: number,
                        });
            }
            break;
        default:
            throw new Error("Didn't expect to get here");
    }
    return mykey;
};
//# sourceMappingURL=ExpandedEventUtils.js.map